import React from 'react';
import { shape, string, array, oneOf } from 'prop-types';

import { namespace, types } from '../../common';
import { LabelComponent } from './label-component';

const VerticalSeparator = () => <div className={`${namespace}-separator`} />;

/**
 * @property {props}
 * @property {string} props.type
 * @property {Object} props.label
 * @returns {React.ReactNode}
 */
export const Renderer = ({ type, ...props }) => {
  if (type === types.VERTICAL_SEPARATOR) {
    return <VerticalSeparator />;
  }

  if (type === types.LABEL_COMPONENT) {
    return <LabelComponent {...props} />;
  }

  return null;
};

const stylesShape = shape({
  font_size: string,
  font_weight: string,
  color: string,
});

Renderer.propTypes = {
  label: shape({
    text: string,
    styles: stylesShape,
    values: array,
  }),
  type: oneOf([types.LABEL_COMPONENT, types.VERTICAL_SEPARATOR]).isRequired,
};
